import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { deleteCppRateCard } from '~/services/LuxLoyalty';

import { costPerPointQueryKeys } from './costPerPointQueryKeys';

/** Deletes a DRAFT rate card and invalidates the list/detail caches. */
export function useDeleteCppRateCard() {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async (id: string) => {
      return await deleteCppRateCard(id);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: costPerPointQueryKeys.all });
      enqueueSnackbar('Rate card deleted successfully', { variant: 'success' });
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Error deleting rate card: ${error.message || 'Unknown error'}`, { variant: 'error' });
    },
  });
}
